/**
 * URLs públicas de cada app.
 * En local → puertos CRA. En producción → subdominios del mismo dominio raíz.
 */
function rootDomainFromHost(host) {
  const h = String(host || '').toLowerCase().replace(/:\d+$/, '');
  if (!h || h === 'localhost' || h === '127.0.0.1') return null;
  const parts = h.split('.');
  if (parts.length >= 3) return parts.slice(1).join('.');
  return h;
}

export function getAppUrls() {
  const host = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  const root = rootDomainFromHost(host);

  if (!root) {
    return {
      vendedor: { href: 'http://localhost:3001', label: 'localhost:3001' },
      admin: { href: 'http://localhost:3003', label: 'localhost:3003' },
      oficina: { href: 'http://localhost:3004', label: 'localhost:3004' },
      bodega: { href: 'http://localhost:3005', label: 'localhost:3005' },
      tienda: { href: 'http://localhost:3002', label: 'localhost:3002' },
      api: { href: 'http://localhost:8081', label: 'localhost:8081' },
    };
  }

  const mk = (sub) => {
    const href = `https://${sub}.${root}`;
    return { href, label: `${sub}.${root}` };
  };

  return {
    vendedor: mk('vendedor'),
    admin: mk('admin'),
    oficina: mk('oficina'),
    bodega: mk('bodega'),
    tienda: mk('tienda'),
    api: mk('api'),
  };
}
